import Routing from '../assets/icons/trvto_routing.svg';
import Messages from '../assets/icons/trvto_messages.svg';
import Note from '../assets/icons/trvto_note.svg';
import Timer from '../assets/icons/trvto_timer.svg';
import Achievement from '../assets/icons/trvto_achievement.svg';
import Truck from '../assets/icons/trvto_truck.svg';
import Places from '../assets/home/trvto_places.png';
import Travel from '../assets/home/trvto_travel.png';
import Explore from '../assets/home/trvto_explore.png';
import One from '../assets/home/trvto_One.svg';
import Two from '../assets/home/trvto_Two.svg';
import Three from '../assets/home/trvto_Three.svg';
import Four from '../assets/home/trvto_Four.svg';
import Goa from '../assets/home/trvto_Switzerland.png';
import Thailand from '../assets/home/trvto_Brazil.png';
import France from '../assets/home/trvto_France.png';
import Singapore from '../assets/home/trvto_Singapore.png';
import Italy from '../assets/home/trvto_Italy.png';
import Dubai from '../assets/home/trvto_Dubai.png';
import FirstBooking from '../assets/home/trvto_FirstBooking.png';

export const WhyUs = [
    {
        id: 1,
        icon: Routing,
        title: 'Diverse Experiences',
        color: '#6056DE',
        background: '#F1F0FF'
    },
    {
        id: 2,
        icon: Messages,
        title: 'Expert Guides',
        color: '#FF9400',
        background: '#FFF9F0'
    },
    {
        id: 3,
        icon: Note,
        title: 'Safety First',
        color: '#3B9C4D',
        background: '#E9FFED'
    },
    {
        id: 4,
        icon: Timer,
        title: 'Authentic and Raw Experience',
        color: '#007AFE',
        background: '#EAF4FF'
    },
    {
        id: 5,
        icon: Achievement,
        title: 'One-Stop Adventure Hub',
        color: '#C15288',
        background: '#FCDFED'
    },
    {
        id: 6,
        icon: Truck,
        title: 'Wide Selection of Organizers',
        color: '#2192A2',
        background: '#DBF3F6'
    }
];

export const DiscountCards = [
    {
        id: 1,
        image: Places,
        description: 'Places',
        path: 'beach'
    },
    {
        id: 2,
        image: Travel,
        description: 'Travel',
        path: 'mountains'
    },
    {
        id: 3,
        image: Explore,
        description: 'Explore',
        path: 'trek'
    }
];

export const Counters = [
    {
        id: 1,
        image: One,
        number: 532,
        title: 'Organizers'
    },
    {
        id: 2,
        image: Two,
        number: 532,
        title: 'Itineraries '
    },
    {
        id: 3,
        image: Three,
        number: 532,
        title: 'Successful Trips'
    },
    {
        id: 4,
        image: Four,
        number: 532,
        title: '5 Star Reviews'
    }
];

export const ExoticPlaces = [
    {
        id: 1,
        image: France,
        count: 8,
        title: 'France'
    },
    {
        id: 2,
        image: Thailand,
        count: 3,
        title: 'Thailand'
    },
    {
        id: 3,
        image: Goa,
        count: 3,
        title: 'Goa'
    },

    {
        id: 4,
        image: Italy,
        count: 8,
        title: 'Italy'
    },
    {
        id: 5,
        image: Dubai,
        count: 4,
        title: 'Dubai'
    },
    {
        id: 6,
        image: Singapore,
        count: 7,
        title: 'Singapore'
    },

    {
        id: 7,
        image: FirstBooking,
        count: 8,
        title: 'FirstBooking'
    }
];

export const SeoLinks = [
    'Trek',
    'Beach',
    'Chickmangalore',
    'Kuduremukha',
    'Goa',
    'Hampi',
    'Gokarna',
    'Mountain',
    'Thaniyadamol',
    'Nandhi hills',
    'Treks from Bengaluru',
    'Kumaraparvatha',
    'Kerala',
    'Wayanad',
    'Puducherry',
    'Udupi',
    'Madikeri',
    'Coorg',
    'Mysuru',
    'Mysore',
    'Dandeli',
    'Goa',
    'Murdeshwara',
    'Karnataka',
    'Belur',
    'Hornadu',
    'Honavara',
    'Adventure',
    'One day trip',
    'Two day trips',
    'Trek',
    'Island',
    'Mountains',
    'Beach',
    'Road trip',
    'Backpacking',
    'Snow',
    'Hike'
];
